<template>
  <TenderPlug
    :title="$t('No archived tenders yet')"
    :description="
      $t(
        'You can add any of the active tenders to the archive and they will appear in this section'
      )
    "
  >
    <template #icon>
      <ArchiveIcon />
    </template>
  </TenderPlug>
</template>

<script>
  import TenderPlug from '@/components/tender/TenderPlug';
  import ArchiveIcon from '@/assets/icons/archive.svg';

  export default {
    name: 'ArchivedTenderPlug',
    components: {
      ArchiveIcon,
      TenderPlug,
    },
  };
</script>
